<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>Trial Balance</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary d-flex justify-center align-center">
          <v-col cols="8">
            <v-data-table
              :items-per-page="1000"
              :headers="headers"
              :items="accountsData"
              :mobile-breakpoint="zeroValue"
              hide-default-footer
            >
              <!-- Credit template -->
              <template v-slot:item.credit="{ item }">
                <span v-if="item.credit > 0">{{item.credit | currency }}</span>
                <span v-else>-</span>
              </template>
              <!-- end -->

              <!-- Debit template -->
              <template v-slot:item.debit="{ item }">
                <span v-if="item.debit > 0">{{item.debit | currency }}</span>
                <span v-else>-</span>
              </template>
              <!-- end -->

               <!-- Debit template -->
               <template v-slot:item.balance="{ item }">
                <span >{{item.balance | currency }}</span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
    
    <script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    headers: [
      { text: "Account Name", value: "account" },
      { text: "Debit", value: "debit" },
      { text: "Credit", value: "credit" },
      { text: "Balance", value: "balance" }
    ],
    accountsData: []
  }),
  methods: {
    getReport() {
      const self = this;
      this.$store
        .dispatch("get", `/trial-balance`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accountsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getReport();
  }
};
</script>